import { gql } from '@apollo/client';
import TaxEvidenceInfo from './TaxEvidenceInfo';

const PartnerTaxExemptionInfo = gql`
  fragment PartnerTaxExemptionInfo on PartnerTaxExemption {
    id
    certificateNumber
    effectiveAt
    exemptionType
    expiresAt
    issuedOn
    jurisdictions
    partnerOrganizationId
    resolutionReason
    state
    taxjarCustomerId
    verifiedAt
    verifiedById
    taxEvidence {
      ...TaxEvidenceInfo
    }
  }
  ${TaxEvidenceInfo}
`;

export default PartnerTaxExemptionInfo;
